<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import messages from './locales/messages'
import BlackFriday from '@/components/BlackFriday.vue';
import ChristmasPromo from '@/components/ChristmasPromo.vue';
import SalonPhoto2026 from '@/components/SalonPhoto2026/index.vue';

const { t, locale } = useI18n({
    useScope: 'global',
    messages
})

const props = defineProps({
    discount:{
        type: [Object, Boolean],
        required: true
    },
    showHT:{
        type: Boolean,
        default: false
    }
})


const emits = defineEmits(['update'])
const code = ref('')

const amount = computed(() => {
    if(props.discount === false){
        return 0
    }
    if(props.showHT){
        return (props.discount.discount_ttc/1.2).toFixed(2)
    }
    return props.discount.discount_ttc
})
const discountName = computed(() => {
    if(props.discount === false){
        return ''
    }
    if(props.discount.type == '%'){
        return props.discount.name +' - '+props.discount.value + '%'
    }
    return props.discount.name;
})
const inputClass = computed(() => {
    if(props.discount === false){
        return ''
    }
    if(!props.discount.result){
        return 'error'
    }
    return '';
})
const errorMessage = computed(() => {
    if(props.discount === false || props.discount.result){
        return ''
    }
    if(!props.discount.result){
        return props.discount.content[locale.value]
    }
})
function applyDiscount(){
    if(code.value && code.value.length > 0){
        emits('update', code.value)
    }
}
function applyPromoCode(promoCode: string){
    code.value = promoCode
    emits('update', promoCode)
}
function deleteDiscount(){
    code.value = ''
    emits('update', '')
}
</script>
<template>
    <form @submit.prevent="applyDiscount">
        <label>{{ $t('cart.promo_code') }}</label>
        <div v-if="!props.discount || !props.discount.result">
            <div class="d-flex justify-space-between ga-2 align-center">
                <input v-model="code" :class="inputClass" type="text" :placeholder="$t('cart.enter_discount_code')" @enter="applyDiscount" />
                <button type="submit">{{ $t('cart.apply_discount_code') }}</button>
            </div>
            <p v-if="errorMessage!=''" class="error">{{ errorMessage }}</p>
            <BlackFriday variant="inline" />
            <ChristmasPromo variant="inline" />
            <SalonPhoto2026 variant="cart" @apply="applyPromoCode" />
        </div>
        <div v-else class="discount">
            
            <div class="w-100 d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                    <v-btn icon variant="text" size="small" @click="deleteDiscount">
                        <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                    <div>{{discountName}}</div>
                </div>
                <div class="text-right text-no-wrap">
                    <strong>-&nbsp;{{ amount }}&nbsp;€</strong>
                </div>
            </div>
        </div>
    </form>
    
</template>
<style lang="scss" scoped>
form{
    margin-top: 30px;
    width: 100%;
}
label{
    width: 100%;
    text-align: left;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 14px;
    line-height: 17.07px;
    letter-spacing: 0%;
    color: #FFF;
}
input{
    width: 100%;
    margin-top: 5px;
    color: #000;
    background-color: #FFF;
    border-radius: 16px;
    padding: 3px 20px 5px 10px;
    transform: all 0.3s;
    height: 32px;
    &.error{
        box-shadow: 0px 0px 15px 0px #FF0000;
    }
}
p.error{
    margin-top: 5px;
    //background-color: #FF000044;
    color: #FF0000;
    padding: 5px;
}
.discount{
    color: #FFF;
    font-size: 14px;
    text-align: left;
}
button[type="submit"]{
    text-align: left;
    background: #5DC5FF;
    border-radius: 17px;
    font-family: Montserrat;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.07px;
    letter-spacing: 0%;
    color: #FFF;
    padding: 10px 20px;
    box-shadow: 0px 0px 4px 0px #00000040 inset;
    transition: all 0.3s;
    &:hover{
        background: #83cff8;
    }

}
</style>